import api from '@/api/index.js'

const pt_zones = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_PT_ZONES_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_PT_ZONES: (state, data) => {
      state.data = data
      state.loading = false;
    },
    SET_PT_ZONES_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    }
  },

  actions: {
    GetPTZones({commit}) {
      commit('SET_PT_ZONES_LOADING', true)
      return api.get('pt-zones?limit=150&offset=0')
        .then((response) => {
          commit('SET_PT_ZONES', response)
          commit('SET_PT_ZONES_LOADING', false)
        })
        .catch((error) => {
          commit('SET_PT_ZONES_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default pt_zones
